<template>
    <div>
        <v-container container--fluid v-if="this.$route.name != 'hpcDashboard'">
            <v-layout row wrap align-center justify-space-around class="pa-sm-2 pa-0 mx-auto">
                <v-flex xs12 class="text-left">
                    <v-btn text color="warning" :to="{ name: 'hpcDashboard' }" class="ma-0 my-2"><v-icon left>arrow_back</v-icon> HPC Dashboard</v-btn>
                </v-flex>
            </v-layout>
        </v-container>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'Hpc',
    components: {
        //components
    },
    data(){
        return {
            //
        }
    },
    beforeCreate() {

    }
}
</script>

<style scoped>

</style>
